var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableBody = void 0;
var TableBody_1 = __importDefault(require("./TableBody"));
exports.TableBody = TableBody_1.default;
exports.default = TableBody_1.default;
//# sourceMappingURL=index.js.map